const messages = {
    accountBox: {
        title: "Tableau de bord",
        description:
            "Ici, vous pouvez consulter votre solde actuel de points de récompense et les mouvements de votre compte.",
        button: "ACCÉDER AU TABLEAU DE BORD",
    },
};

export default {
    messages,
};
